/**
 * Outbox NotificationKey ile aynı dize: platform|sipariş kimliği|new-order.
 * processedOrdersRef ve useNewOrderQueue bu anahtarı kullanır.
 */
export function platformNewOrderNotificationKey(
  platform: 'migros' | 'yemeksepeti' | 'trendyol',
  orderId: string | number | null | undefined,
): string {
  return `${platform}|${orderId ?? ''}|new-order`;
}

export function migrosNewOrderNotificationKey(order: {
  migrosOrderId?: string | number | null;
  MigrosOrderId?: string | number | null;
  id?: string | number | null;
  Id?: string | number | null;
}): string {
  const id = order.migrosOrderId ?? order.MigrosOrderId ?? order.id ?? order.Id;
  return platformNewOrderNotificationKey('migros', id);
}

export function ysNewOrderNotificationKey(order: {
  remoteOrderId?: string | null;
  RemoteOrderId?: string | null;
  token?: string | null;
  Token?: string | null;
  id?: string | number | null;
  Id?: string | number | null;
}): string {
  const id = order.remoteOrderId ?? order.RemoteOrderId ?? order.token ?? order.Token ?? order.id ?? order.Id;
  return platformNewOrderNotificationKey('yemeksepeti', id);
}
